<template>
    <div>
        <b-button :type="signingNeeded || loading || noFilesToSign ? 'is-primary' : 'is-success'" :icon-left="signingNeeded ? '' : 'check'" @click="showModal = true" :disabled="loading || noFilesToSign" :loading="loading" v-show="showButton">Documenten tekenen</b-button>

        <b-modal :active.sync="showQR" id="contractSignDocumentsModalQR" aria-modal :width="600" :can-cancel="true" style="z-index:99999999;text-align:center;">
            <div class="modal-card-body" style="border-radius:4px;">
                <b-notification type="is-success" role="alert" v-if="QRPageOpened">
                    De pagina is geopend, deze pop-up kan nu gesloten worden.
                </b-notification>
                <p v-else>Scan de QR code met je telefoon om naar de webpagina te gaan om te tekenen.</p>

                <qrcode-vue :value="qr" :size="500" level="H" />
                <br>
                <a :href="qr" target="_blank" class="button is-primary is-small" @click="showQR = false">Open de tekenpagina op dit apparaat</a>
            </div>
            <footer class="modal-card-foot text-right">
                <b-button type="is-light" @click="showQR = false">Sluiten</b-button>
            </footer>
        </b-modal>

        <b-modal :active.sync="showModal" id="contractSignDocumentsModal" aria-modal :width="600" :can-cancel="true" :key="refreshKey">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head"><p class="modal-card-title">Documenten tekenen</p></header>
            </div>
            <section class="modal-card-body" style="overflow: hidden;border-radius:0;text-align:left;">
                <p v-if="signingNeeded">
                    {{ signingNeeded == 1 ? 'Er is nog een document dat ondertekend moet worden' : 'Er zijn nog enkele documenten die ondertekend moeten worden' }}&nbsp;voor voltooiing van het contract. Klik op "Document(en) tekenen" om een QR-code te genereren waarmee eenvoudig een telefoon gebruikt kan worden om {{ signingNeeded == 1 ? 'het document' : 'de documenten' }} te ondertekenen.
                    <br>
                    Als de bestanden op een andere manier al zijn getekend dan kan je de knop naast het document klikken om het te markeren als getekend.
                </p>
                <p v-else>Alle documenten zijn getekend!</p>
                <p v-show="!!qr && signingNeeded">De QR code is gescant, er wordt elke 5 seconden gecontroleerd of {{ signingNeeded == 1 ? 'het document' : 'de documenten' }} getekend {{ signingNeeded == 1 ? 'is' : 'zijn' }}.</p>

                <b-table :data="files" :loading="loading">
                    <template>
                        <b-table-column v-slot="props" field="name" label="Document">
                            {{ props.row.name }}
                        </b-table-column>
                        <b-table-column v-slot="props" field="signed" label="Getekend" numeric>
                            <span v-if="props.row.signed != 0">
                                <b-tooltip label="Document is getekend!" position="is-left">
                                    <b-button type="is-success" size="is-small" icon-right="check" @click="markAsUnsigned(props.row.id)"></b-button>
                                </b-tooltip>
                            </span>
                            <span v-else>
                                <b-tooltip label="Markeer als getekend" position="is-left">
                                    <b-button type="is-success" outlined size="is-small" @click="markAsSigned(props.row.id)" icon-right="check"></b-button>
                                </b-tooltip>
                            </span>
                        </b-table-column>
                    </template>
                </b-table>
            </section>
            <footer class="modal-card-foot text-right">
                <b-button type="is-light" @click="showModal = false">Sluiten</b-button>
                <b-button type="is-primary" v-show="signingNeeded" @click="showOrCreateQR">Documenten tekenen</b-button>
            </footer>
        </b-modal>
    </div>
</template>

<script>
import toastMixins from '@/mixins/toastMixins.js'
import QrcodeVue from 'qrcode.vue'

export default {
    name: 'ContractsSignDocumentsModal',

    mixins: [toastMixins],

    components: {
        QrcodeVue
    },

    props: {
        showButton: {
            type: Boolean,
            required: false,
            default: true
        },
        contractId: {
            type: Number|String,
            required: true
        },
        includedFrom: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            refreshKey: 0,
            intervalFiles: null,
            intervalQR: null,
            showModal: false,
            loading: false,
            files: [],
            showQR: false,
            qr: null,
            QRPageOpened: false,
            firstQRinit: true,
            noFilesToSign: false,
        }
    },

    computed: {
        signingNeeded() {
            return _.filter(this.files, {signed: 0}).length
        }
    },

    created() {
        this.startUp()
    },

    methods: {
        startUp() {
            if (this.startingUp) return false;

            this.startingUp = true // lets make sure we only start one simultaneous request
            this.loading = true

            axios.get('/api/contract/'+this.contractId+'/sign-documents', {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if (!response.data.length) {
                    this.noFilesToSign = true
                    console.log('No files to be signed!');
                }

                // Show modal if included from connect or contract and files need to be signed.
                if (this.includedFrom && (this.includedFrom === 'connect' || this.includedFrom === 'contract') && response.data.length) {
                    if (!!response.data.filter((x) => {return x.signed === 0}).length) {
                        if (this.$route.query && this.$route.query.nieuw) {
                            this.showModal = true
                        }
                    }
                }

                this.files = response.data
                this.loading = false
                this.refreshKey = this.refreshKey + 1
            }).catch((error) => {
                console.log(error)
            }).then(() => {
                this.startingUp = false
            })
        },

        markAsSigned(id){
            this.loading = true

            axios.post('/api/contract/'+this.contractId+'/sign-documents/'+id, {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.loading = false
                this.startUp()
            }).catch(() => {
                this.refreshKey = this.refreshKey + 1
                this.showError('Er is iets fout gegaan! Probeer het opnieuw.')
                this.loading = false
                this.startUp()
            })
        },

        markAsUnsigned(id) {
            this.markAsSigned(id)
        },

        showOrCreateQR() {
            this.loading = true

            axios.post('/api/contract/'+this.contractId+'/sign-documents/qr', {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.loading = false

                // Set the QR
                this.qr = response.data.url

                // Close if its opened.
                if(response.data.status === 'opened' && this.showQR){
                    this.QRPageOpened = true
                    clearInterval(this.intervalQR)
                    return false
                } else {
                    this.showQR = true
                }

                if(this.firstQRinit) {
                    this.intervalQR = setInterval(() => {
                        this.showOrCreateQR()
                    }, 2500)

                    this.firstQRinit = false
                }
            }).catch(() => {
                this.showError('Er is iets fout gegaan! Probeer het opnieuw.')
                this.loading = false
            })
        },

        toggleModal() {
            this.showModal = !this.showModal
        }
    },

    watch: {
        showModal(newVal) {
            if (!newVal) {
                clearInterval(this.intervalFiles)
                clearInterval(this.intervalQR)
                this.firstQRinit = true

                if (!this.signingNeeded){
                    this.$emit('reload')
                }
            }
        },

        signingNeeded(newVal) {
            if (!newVal) {
                clearInterval(this.intervalFiles)
                clearInterval(this.intervalQR)
                this.firstQRinit = true
            }
        },

        showQR(newVal) {
            if (newVal) {
                // First clear any other running intervals
                clearInterval(this.intervalFiles)

                this.intervalFiles = setInterval(() => {
                    this.startUp()
                }, 5000)
            } else {
                this.QRPageOpened = false
                this.firstQRinit = true
                clearInterval(this.intervalQR)
            }
        }
    }
}
</script>